<template>
  <div class="CountDown">
    <span class="_user-select">{{ hourString }}</span>
    <span class="icon_colon">:</span>
    <span class="_user-select">{{ minuteString }}</span>
    <span class="icon_colon">:</span>
    <span class="_user-select">{{ secondString }}</span>
  </div>
</template>

<script>
export default {
  name: "CountDown",
  data() {
    return {
      hour: '',
      minute: '',
      second: '',
      promiseTimer: '',
    }
  },
  props: {
    remainTime: {    // 倒计时间总秒数
      default: ''
    }
  },
  watch:{
    remainTime:{
      handler(n,o){
        console.log(n)
        this.hour = Math.floor((n / 3600) % 24)
        this.minute = Math.floor((n / 60) % 60)
        this.second = Math.floor(n % 60)
        this.countDowm()
      }
    }
  },
  mounted() {
    if (this.remainTime > 0) {
      console.log(this.remainTime)
      this.hour = Math.floor((this.remainTime / 3600) % 24)
      console.log(this.hour)
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm()

      // var endDate = new Date(this.list.activityEndDate);
      this.getEndDate(this.remainTime)
    }
  },
  methods: {
    // 截止日期倒计时功能
    getEndDate(end) {
      console.log('截止日期倒计时功能')
      // countDownTime: '距结束 3 天 8 时 50 分 20 秒',
      var date = new Date();
      var now = date.getTime();
      //设置截止时间
      var leftTime = end - now;
      //定义变量 d,h,m,s保存倒计时的时间
      var d, h, m, s;
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
        m = Math.floor(leftTime / 1000 / 60 % 60);
        s = Math.floor(leftTime / 1000 % 60);
        //递归每秒调用countTime方法，显示动态时间效果
        this.countDownTime = `距结束 ${d} 天 ${h} 时 ${m} 分 ${s} 秒`
        console.log(this.countDownTime)
        setInterval(()=>{
          this.getEndDate(end)
        },1000)
      }else{
        this.countDownTime = '活动已结束'
      }
    },
    countDowm() {
      var self = this
      clearInterval(this.promiseTimer)
      this.promiseTimer = setInterval(function () {
        if (self.hour === 0) {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59
            self.minute -= 1
          } else if (self.minute === 0 && self.second === 0) {
            self.second = 0
            self.$emit('countDowmEnd', true)
            clearInterval(self.promiseTimer)
          } else {
            self.second -= 1
          }
        } else {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59
            self.minute -= 1
          } else if (self.minute === 0 && self.second === 0) {
            self.hour -= 1
            self.minute = 59
            self.second = 59
          } else {
            self.second -= 1
          }
        }
      }, 1000)
    },
    formatNum(num) {
      return num < 10 ? '0' + num : '' + num
    }
  },
  computed: {
    hourString() {
      return this.formatNum(this.hour)
    },
    minuteString() {
      return this.formatNum(this.minute)
    },
    secondString() {
      return this.formatNum(this.second)
    }
  }
}
</script>

<style lang="scss" scoped>
.CountDown{
  text-align: center;

  display: flex;
  font-size: 0;


  ._user-select{
    display: inline-block;
    width: 32px;
    height: 32px;
    background: #F8FDFF;
    border-radius: 4px;
    font-size: 25px;
    font-weight: bold;
    color: #FD5807;

  }
  .icon_colon{
    font-size: 20px;
    font-weight: bold;
    color: #FFDF89;
    margin: 0 5px;
  }
}
</style>
